import React, {Fragment, useState} from 'react';
import MetaTags from 'react-meta-tags';
import {useTranslation} from 'react-i18next';

import Loading from '../blocks/loading/Loading';
import Header from '../blocks/header/Header';
import Footer from '../blocks/footer/Footer';

const FAQ = () => {
  const {t} = useTranslation();
  const [openItem, setOpenItem] = useState(null);
  const items = t('faq.items', {returnObjects: true});

  return (
    <Fragment>
      <MetaTags>
        <meta charSet="UTF-8" />
        <title>{t('faq.meta_title')}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="description" content={t('faq.intro')} />
        <meta name="robots" content="index, follow" />
      </MetaTags>

      <Loading />
      <Header logoColor="dark" />

      <main id="main" className="site-main faq-page">
        <div id="page-title">
          <div className="wrapper text-center">
            <span className="faq-page-kicker">FAQ</span>
            <h1 className="large">{t('faq.title')}</h1>
            <p className="faq-page-intro">{t('faq.intro')}</p>
          </div>
        </div>

        <section className="faq-list wrapper" aria-label={t('faq.title')}>
          {Array.isArray(items) && items.map((item, index) => {
            const isOpen = openItem === index;
            const answerId = `faq-answer-${index}`;
            return (
              <article className={`faq-item${isOpen ? ' is-open' : ''}`} key={item.question}>
                <h2 className="faq-question-heading">
                  <button
                    className="faq-question"
                    type="button"
                    aria-expanded={isOpen}
                    aria-controls={answerId}
                    onClick={() => setOpenItem(isOpen ? null : index)}
                  >
                    <span>{item.question}</span>
                    <span className="faq-toggle" aria-hidden="true" />
                  </button>
                </h2>
                <div className="faq-answer-wrap" id={answerId} aria-hidden={!isOpen}>
                  <div className="faq-answer">
                    <p>{item.answer}</p>
                  </div>
                </div>
              </article>
            );
          })}
        </section>
      </main>

      <Footer />
    </Fragment>
  );
};

export default FAQ;
